var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-globe",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-globe1",
    serifid: "iconB-globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12,1c6.075,0 11,4.925 11,11c0,6.075 -4.925,11 -11,11c-6.075,0 -11,-4.925 -11,-11c0,-6.075 4.925,-11 11,-11Zm-2.274,19.71c-0.964,-1.448 -1.688,-3.039 -2.147,-4.71l-3.643,0c1.145,2.305 3.249,4.049 5.79,4.71Zm-6.503,-6.71l3.939,0c-0.093,-0.653 -0.148,-1.314 -0.162,-1.979c-0,-0.014 -0,-0.028 0,-0.042c0.014,-0.665 0.069,-1.326 0.162,-1.979l-3.939,0c-0.146,0.643 -0.223,1.313 -0.223,2c0,0.687 0.077,1.357 0.223,2Zm0.713,-6l3.643,0c0.459,-1.671 1.183,-3.262 2.147,-4.71c-2.541,0.661 -4.645,2.405 -5.79,4.71Zm10.338,-4.71c0.964,1.448 1.688,3.039 2.147,4.71l3.643,-0c-1.145,-2.305 -3.249,-4.049 -5.79,-4.71Zm6.503,6.71l-3.939,-0c0.093,0.653 0.148,1.314 0.162,1.979c0,0.014 0,0.028 -0,0.042c-0.014,0.665 -0.069,1.326 -0.162,1.979l3.939,-0c0.146,-0.643 0.223,-1.313 0.223,-2c0,-0.687 -0.077,-1.357 -0.223,-2Zm-0.713,6l-3.643,-0c-0.459,1.671 -1.183,3.262 -2.147,4.71c2.541,-0.661 4.645,-2.405 5.79,-4.71Zm-8.064,4.449c1.039,-1.338 1.827,-2.845 2.334,-4.449l-4.67,0c0.508,1.602 1.296,3.11 2.336,4.449Zm-2.814,-6.449l5.626,0c0.109,-0.664 0.172,-1.339 0.187,-2.02c-0.015,-0.667 -0.078,-1.328 -0.185,-1.98l-5.626,0c-0.109,0.664 -0.172,1.339 -0.187,2.019c0.015,0.668 0.078,1.329 0.185,1.981Zm0.48,-6l4.67,-0c-0.508,-1.602 -1.296,-3.11 -2.336,-4.449c-1.039,1.338 -1.827,2.845 -2.334,4.449Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBGlobe);
export default __webpack_public_path__ + "static/media/iconB-globe.a8cd51f631747a7f74621e7bbae8a702.svg";
export { ForwardRef as ReactComponent };